export default function ({ store, $sentry }) {
  if (store.state.user) {
    $sentry.configureScope(function (scope) {
      scope.setUser({ email: store.state.user.email, id: store.state.user.id });
    });
  } else {
    $sentry.configureScope((scope) => scope.setUser(null));
  }
}
